module.exports = [{
      plugin: require('../node_modules/.pnpm/gatsby-plugin-google-analytics@2.11.0_gatsby@2.32.13_react-dom@16.14.0_react@16.14.0/node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-XXX-1","head":false,"anonymize":false,"respectDNT":false,"exclude":[],"pageTransitionDelay":0},
    }]
